export const environment = {
  production: false,
  API_URL: 'https://uat-api.deckpro.in/',
  // API_URL2: 'https://uat-api.deckpro.in/',
  // API_URL: 'http://65.1.90.215:3000/',
  // API_URL2: 'http://65.1.90.215:3000/',
  image_Url: 'https://d2volhcdqujz77.cloudfront.net/',
  Eng: '6',
  Guj: '7',
  Hin: '9',
  Ben: '10',
  CRYPTO_SECRET_KEY: '1ed1anHiWnlUl6NETwdmoPk',
  maintenanceMode: false,
  loginPermission: true,
};